// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/share.proto (package tabgraph.v1, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1 defines the canonical data types and services for the
// tabgraph application.

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/share.proto.
 */
export const file_tabgraph_v1_share: GenFile = /*@__PURE__*/
  fileDesc("Chd0YWJncmFwaC92MS9zaGFyZS5wcm90bxILdGFiZ3JhcGgudjEinQEKClNoYXJlVG9rZW4SCgoCaWQYASABKAkSEgoKc2Vzc2lvbl9pZBgCIAEoCRIuCgpleHBpcmVzX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIPCgdyZXZva2VkGAQgASgIEi4KCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQkdaRWdpdGh1Yi5jb20vc3RyYXR1c3N0dWRpb3MvdGFiZ3JhcGgvYmFja2VuZC9nZW4vdGFiZ3JhcGgvdjE7dGFiZ3JhcGh2MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * ShareToken represents a shareable link to a session graph. The server stores
 * only the SHA-256 hash of the raw token; the raw token is returned once at
 * creation time and never stored in plaintext.
 *
 * @generated from message tabgraph.v1.ShareToken
 */
export type ShareToken = Message<"tabgraph.v1.ShareToken"> & {
  /**
   * id is the unique share token record identifier, prefixed shr_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * session_id is the session this share link grants read access to.
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * expires_at is when this share link expires and becomes invalid.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * revoked indicates whether this share link has been manually revoked before
   * its expiry.
   *
   * @generated from field: bool revoked = 4;
   */
  revoked: boolean;

  /**
   * created_at is when this share link was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message tabgraph.v1.ShareToken.
 * Use `create(ShareTokenSchema)` to create a new message.
 */
export const ShareTokenSchema: GenMessage<ShareToken> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_share, 0);

